/**
 * One horizontal hairline.
 *
 * It has no VARIANTS on purpose — no orientation, no weight, no tone, which is
 * what §2.1's "No props" says about it. The VERTICAL tick between inline facts
 * is not a public primitive either: it is internal to `CresultcardFactLine`,
 * because a hand-placed separator is how a chain of middle dots gets written.
 */
"use client";
import type { ReactElement } from "react";
import { CRC_DIVIDER } from "./cresultcard.tokens";

export function CresultcardRule(): ReactElement {
  return (
    <span
      aria-hidden
      data-el="Cresultcard/Rule/Root"
      style={{ height: 1, flexShrink: 0, backgroundColor: CRC_DIVIDER }}
    />
  );
}
